module.exports = __webpack_public_path__ + "static/media/loading_dots.8c077453.gif";